export const WARDROBES_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Стеклянные двери-купе',
    addText: 'с черным профилем',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1010,
  },
  {
    displayedName: 'Гардеробная ',
    addText: 'со светлыми дверями-купе',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1020,
  },
  {
    displayedName: 'Вместительная гардеробная ',
    addText: 'в белом цвете',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1057,
  },
  {
    displayedName: 'Большая гардеробная',
    addText: 'с открытым хранением ',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1066,
  },
  {
    displayedName: 'Белые двери-купе',
    addText: 'с яркими вставками',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1042,
  },
  {
    displayedName: 'Белая гардеробная',
    addText: 'с туалетным столиком',
    mediaMainPhoto: ['6.jpg/06.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1022,
  },
  {
    displayedName: 'Просторная гардеробная ',
    addText: 'в цвете венге и бетон',
    mediaMainPhoto: ['7.jpg/07.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1023,
  },
  {
    displayedName: 'Угловая гардеробная',
    addText: 'с ящиками',
    mediaMainPhoto: ['8.jpg/08.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1067,
  },
  {
    displayedName: 'Стеклянные двери-купе',
    addText: 'с золотым профилем',
    mediaMainPhoto: ['9.jpg/09.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1004,
  },
  {
    displayedName: 'Угловая гардеробная ',
    addText: 'со стеклянными дверьми-купе',
    mediaMainPhoto: ['10.jpg/010.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1026,
  },
  {
    displayedName: 'Прачечная',
    addText: '',
    mediaMainPhoto: ['11.jpg/011.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1027,
  },
  {
    displayedName: 'Небольшая гардеробная',
    addText: 'в оттенке «Дуб Сонома»',
    mediaMainPhoto: ['12.jpg/012.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1050,
  },
  {
    displayedName: 'Современная гардеробная',
    addText: 'с открытым хранением',
    mediaMainPhoto: ['13.jpg/013.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1015,
  },

  {
    displayedName: 'Вместительная гардеробная ',
    addText: 'в белом цвете',
    mediaMainPhoto: ['14.jpg/14.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1001,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с декоративной вставкой',
    mediaMainPhoto: ['15.jpg/15.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1007,
  },
  {
    displayedName: 'Угловая гардеробная',
    addText: 'со стеклянными дверьми-купе',
    mediaMainPhoto: ['16.jpg/16.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1046,
  },
  {
    displayedName: 'Двери-купе ',
    addText: 'в стиле «Лофт»',
    mediaMainPhoto: ['17.jpg/17.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 0,
  },
  {
    displayedName: 'Гардеробная',
    addText: 'белая угловая',
    mediaMainPhoto: ['18.jpg/18.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1031,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с узором',
    mediaMainPhoto: ['19.jpg/19.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1049,
  },
  {
    displayedName: 'Белая гардеробная',
    addText: 'в чёрном профиле',
    mediaMainPhoto: ['20.jpg/20.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1080,
  },
  {
    displayedName: 'Стеклянные двери-купе',
    addText: 'с золотым профилем',
    mediaMainPhoto: ['21.jpg/21.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 0,
  },
  {
    displayedName: 'Белая гардеробная ',
    addText: 'с туалетным столиком',
    mediaMainPhoto: ['22.jpg/22.jpg'],
    productName: '',
    style: 'wardrobes',
    rating: 1078,
  },
];
